export class LTS {
  getOptions() {
    return {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true
    };
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/i18n/date/TimeSeconds.js
 **/